import classNames from 'classnames';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACMissingContentError = ({
  className,
  href,
  to = '/',
  'data-test-id': dataTestId = 'missing-content-error'
}) => /*#__PURE__*/_jsxs(UIErrorMessage, {
  className: classNames('missing-content-error', className),
  "data-test-id": dataTestId,
  type: "notFound",
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.subheading"
    })
  }), href ? /*#__PURE__*/_jsx(UIButton, {
    href: href,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  }) : /*#__PURE__*/_jsx(UIRouterButton, {
    to: to,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.errors.missingContent.button"
    })
  })]
});
export default ACMissingContentError;